export default "__VITE_ASSET__DSy3gXhC__"